import { UserNotificationGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { NotificationKeys } from '@services/notification/keys';
export const useNotificationSummary = (userId?: string) => {
  const client = useClient();
  const url = `user/${userId}/notification/summary`;
  return useQuery<UserNotificationGetResponse, Error>({
    queryKey: NotificationKeys.summary,
    queryFn: () => client.get(url).json<UserNotificationGetResponse>(),
    enabled: !!userId,
    staleTime: 120000,
  });
};
